import { ExtractTagSelect } from '@/pages/CustomCenter/ExtractConfig/components/workflow/components/extract-tag-select';
import { useStore } from '@/pages/CustomCenter/ExtractConfig/components/workflow/store';
import {
  BaseFormExposeRef,
  BaseFormProps,
} from '@/pages/CustomCenter/ExtractConfig/components/workflow/types';
import { Button, Form, GetProp } from 'antd';
import { tryit } from 'radash';
import {
  ForwardRefRenderFunction,
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
} from 'react';
import AnnotationCard from './annotation-card';
import TrainCard from './train-card';

import { convertFrom, convertTo } from './utils';
export interface FormType {
  tags: {
    text_tags: {
      tag_code: string;
      tag_name: string;
    }[];
    table_tags: {
      table_code: string;
      table_name: string;
      tags: {
        tag_code: string;
        tag_name: string;
      }[];
    }[];
  };
  // ignore_headers: boolean;
}

export interface ReturnType {
  form: FormType;
}

export type NlpFormProps = BaseFormProps<FormType>;

const ExtractTagSelectItem = <T extends FormType['tags']>(props: {
  value?: T;
  onChange?: (v?: T) => void;
}) => {
  const handleChange: GetProp<typeof ExtractTagSelect, 'onChange'> = (_, v) => {
    const tags = convertTo(v);
    props.onChange?.(tags as T);
  };

  const value = convertFrom((props.value || []) as T);

  return (
    <ExtractTagSelect
      mode="multiple"
      // onTagChange={handleChange}
      acceptedTypes={['text', 'table']}
      onChange={handleChange}
      value={value}
    />
  );
};

const PanelForm: ForwardRefRenderFunction<
  BaseFormExposeRef<ReturnType>,
  NlpFormProps
> = ({ initialValue, node_id, readonly }, ref) => {
  const [form] = Form.useForm<FormType>();
  const template_code = useStore((s) => s.template_code);

  useImperativeHandle(ref, () => ({
    assembleForm: async () => {
      const [err, values] = await tryit(form.validateFields)();

      if (err) return;

      return {
        form: {
          ...values,
        },
      };
    },
  }));

  useEffect(() => {
    form.setFieldsValue(initialValue || {});
  }, [initialValue, form]);

  return (
    <div>
      <Form disabled={readonly} form={form} layout="vertical" name="nlp-form">
        {/* <Form.Item name={'range'} label="抽取范围">
          <Select
            placeholder="请选择抽取范围"
            options={[
              {
                label: '全文',
                value: 'all',
              },
            ]}
          />
        </Form.Item> */}
        {/* 忽略页眉页脚 */}
        {/* <Form.Item<FormType> valuePropName="checked" name="ignore_headers">
          <Checkbox>忽略页眉页脚</Checkbox>
        </Form.Item> */}
        {/* 抽取字段 Select tag 多选 */}
        <Form.Item<FormType>
          name="tags"
          label="抽取字段"
          rootClassName="[&_.modern-select-selection-item]:!bg-[#F4F7FF]"
        >
          <ExtractTagSelectItem />
        </Form.Item>
        <Form.Item label="数据标注">
          <AnnotationCard node_uid={node_id!} template_code={template_code!} />
        </Form.Item>
        <Form.Item className="w-full">
          <TrainCard
            node_uid={node_id!}
            template_code={template_code!}
            readonly={readonly}
          />
        </Form.Item>
        {/* <Form.Item label="模型训练和测评">
          <DeployCard />
        </Form.Item> */}
      </Form>
    </div>
  );
};

export default memo(forwardRef(PanelForm));
